import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../Store';

export default function RouteProtection({ children }) {
  const { state } = useContext(Store);
  const { infoUtilisateur } = state;
  return infoUtilisateur ? children : <Navigate to="signin" />;
}
